import _ from 'lodash';

import * as types from '../constants/actionTypes';

export function addSnackbar(snackbar) {
    return dispatch => {
        return dispatch({
            type: types.ADD_SNACKBAR,
            payload: {
                snackbar: {
                    id: _.uniqueId('snackbar-'),
                    ...snackbar
                }
            }
        });
    };
}

export function removeSnackbar(id) {
    return dispatch => {
        return dispatch({
            type: types.REMOVE_SNACKBAR,
            payload: {
                id
            }
        });
    };
}


// WEBPACK FOOTER //
// ./src/actions/snackbarActions.js